<template>
  <section :id="galleryID" class="product-intro card">
    <h3 class="title">{{ $t('product_desc') }}</h3>
    <collapsible-article class="text-article my-4" :expand-btn-text="$t('all_show_all')" :max-height="400" :mask="true">
      <content-data v-for="(node, idx) in productIntro" :key="idx" :node="node"></content-data>
    </collapsible-article>
  </section>
</template>

<script setup lang="ts">
import CollapsibleArticle from '@/components/common/collapsible-article.vue'
import ContentData from '@/components/common/content-data.vue'

import type { UiProductInfo } from '@/types/product'

const props = defineProps<{
  product: UiProductInfo
}>()

const galleryID = 'product-intro'
const { lightboxInit } = useLightbox(galleryID)

const productIntro = computed(() => props.product?.product_intro ?? [])

onMounted(() => {
  lightboxInit()
})
</script>

<style lang="scss" scoped></style>
